import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {
  toggleMicrocentrifugeLid,
  toggleMicrocentrifugeControlsModal ,
  toggleMicrocentrifugeTooltipsControls,
  toggleMicrocentrifugeBalanceTubeModal,
  setMicrocentrifugeRPM,
  setMicrocentrifugeTime,
  ejectMicrocentrifugeTubes,
  ejectMicrocentrifugeRotors,
  checkMicrocentrifugeBalance,
  onMicrocentrifugeTubeDrop,
  onMicrocentrifugeInsertItem,
  onMicrocentrifugeRun,

  setSolutionInScene,
  setRotorAdaptersInScene,
  setSolutionOnRack, 
  addTubeToIceBucket,
  setSolutionOnIce
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].type,
    isOpen: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].isOpen,

    showControlsModal: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].showControlsModal,
    showTooltipControls: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].showTooltipControls,
    showBalanceTubeModal: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].showBalanceTubeModal,

    slots: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].slots,
    balanced: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].balanced,
    rpmValue: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].rpmValue,
    timeValue: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].timeValue,
    timeLeft: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].timeLeft,
    centrifugeRunnable: state.notebook.protocolSection.scene.apparatus.microcentrifuge[ownProps.id-1].centrifugeRunnable
  }
}

function mapDispatchToProps(dispatch) {
  return {
    toggleMicrocentrifugeLid: (data)=>{
       dispatch(toggleMicrocentrifugeLid(data))
    },
    toggleMicrocentrifugeControlsModal: (data)=>{
       dispatch(toggleMicrocentrifugeControlsModal(data))
    },
    toggleMicrocentrifugeBalanceTubeModal: (data)=>{
       dispatch(toggleMicrocentrifugeBalanceTubeModal(data))
    },
    toggleMicrocentrifugeTooltipsControls: (data)=>{
       dispatch(toggleMicrocentrifugeTooltipsControls(data))
    },
    setMicrocentrifugeRPM: (data)=>{
       dispatch(setMicrocentrifugeRPM(data))
    },
    setMicrocentrifugeTime: (data)=>{
       dispatch(setMicrocentrifugeTime(data))
    },
    ejectMicrocentrifugeTubes: (data)=>{
       dispatch(ejectMicrocentrifugeTubes(data))
    },
    ejectMicrocentrifugeRotors: (data)=>{
       dispatch(ejectMicrocentrifugeRotors(data))
    },
    onMicrocentrifugeTubeDrop: (data)=>{
       dispatch(onMicrocentrifugeTubeDrop(data))
    },
    checkMicrocentrifugeBalance: (data)=>{
       dispatch(checkMicrocentrifugeBalance(data))
    },
    onMicrocentrifugeInsertItem: (data)=>{
       dispatch(onMicrocentrifugeInsertItem(data))
    },
    onMicrocentrifugeRun: (data)=>{
       dispatch(onMicrocentrifugeRun(data))
    },
    setSolutionInScene: (data)=>{
       dispatch(setSolutionInScene(data))
    },
    setRotorAdaptersInScene: (data)=>{
       dispatch(setRotorAdaptersInScene(data))
    },
    setSolutionOnRack: (data) => {
      dispatch(setSolutionOnRack(data))
    },

    addTubeToIceBucket: (data) => {
      dispatch(addTubeToIceBucket(data))
    },
    setSolutionOnIce: (data) => {
      dispatch(setSolutionOnIce(data))
    },
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
